<template>
	<div class="d-flex align-center">
		<v-btn
			class="mx-2 my-1"
			rounded
			color="#2D4B95"
			dark
			raised
			small
			v-if="checkApprovalChecks && checkPermissions(['change_status_additionals']) && isItoUser"
			@click="changeStatusAdditional(additionalStatuses.ACCEPTED)"
		>
			<p class="mb-0">Aceptar Adicional</p>
		</v-btn>
		<div>
			<ApprovalChecks
				:item="additional"
				item_type="additional"
				:roles_needed="requiredRoles"
				v-if="additional && itemAprovalCheck"
				@onChange="reloadInfo"/>
		</div>
	</div>
</template>

<script>
import ApprovalChecks from '@/components/Globals/Helpers/ApprovalChecks'
import additionalStatuses from '@/helpers/constants/additional.js'

export default {
	name: 'AdditionalClosure',
	components: {
		ApprovalChecks
	},
	props: {
		additional: {
			type: Object,
			required: true
		}
	},
	computed: {
		isItoUser() {
			return this.additional.userprojectjobtype.job_type_id === 4
		},
		availableProfiles() {
			const creator = { id: -1, name: 'Creador',       description: 'Creador del ítem' }
			return [creator, ...this.$store.projectsStore.state.projectProfiles]
		},
    selectedProject() {
      return this.$store.projectsStore.state.selectedProject
    },
		itemAprovalCheck() {
			return this.selectedProject.closure_config.find(config => config.item_type === 3 && config.use_advanced_closure)
		},
		requiredRoles() {
			return this.itemAprovalCheck ? this.itemAprovalCheck.advanced_closure_profiles : []
		},
		approvalChecks(){
			return this.additional.approval_checks
		},
		checkApprovalChecks(){
			if(!this.itemAprovalCheck) return true
			
			const createdBy = this.additional.created_by

			return this.requiredRoles.every(roleId => {
				if (roleId === -1) {
					return this.approvalChecks.some(item => item.user_id === createdBy)
				}
				return this.approvalChecks.some(item => item.job_type === roleId)
			})
		}
	},
	data() {
		return {
			additionalStatuses
		}
	},
	mounted() {
	},
	methods: {
		changeStatusAdditional(status) {
			this.$emit('changeStatusAdditional', status)
		},
		reloadInfo() {
			this.$emit('reloadInfo')
		}
	}
}
</script>

<style>

</style>